import { render, staticRenderFns } from "./noteable_warning.vue?vue&type=template&id=8abd2aa2&"
import script from "./noteable_warning.vue?vue&type=script&lang=js&"
export * from "./noteable_warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports